import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  getInventories: async ({ commit }, { data }) => {
    const { limit, page, order, search } = data
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.get('/inventories', {
        params: {
          limit,
          page,
          order,
          search
        }
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'inventories',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  insert: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.post('/inventories', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  get: async ({ commit }, id) => {
    try {
      const res = await axios.get(`/inventories/${id}`)
      commit('SET_STATE', {
        action: 'inventory',
        data: {
          ...res.data.inventory,
          ingredients: res.data.ingredient
        }
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  removeIngredientById: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      await axios.delete(`/inventories/${id}/delete-ingredient`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  getCategoryOption: async () => {
    try {
      const res = await axios.get('/inventories/category-list', {
        params: {
          limit: 0,
          page: 1
        }
      })
      return {
        data: res.data.category.map(category => ({
          value: category.id,
          label: category.category_name
        })),
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  getIngredientOption: async ({ commit }) => {
    try {
      const res = await axios.get('/inventories', {
        params: {
          limit: 0,
          page: 1
          // action: 'greaterThanZero'
        }
      })
      const data = res.data.data.map(inventory => ({
        ...inventory,
        value: inventory.inventories_id,
        label: `${inventory.inventories_inventory_name} - (${inventory.batch_batch_number})`
      }))
      commit('SET_STATE', {
        action: 'ingredients',
        data
      })
      return {
        data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject(message)
    }
  },
  update: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`inventories/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  delete: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await await axios.delete(`/inventories/${id}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  updateQuantity: async (_, { id, data }) => {
    try {
      const res = await axios.put(`inventories/${id}/update-history-quantity`, data)
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)

      return Promise.reject({ message })
    }
  },
  getHistoricalList: async ({ commit }, { id, data }) => {
    const { limit, page, order, search } = data
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.get(`inventories/${id}/history-list`, {
        params: {
          limit,
          page,
          order,
          search
        }
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'inventory-histories',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'inventory-total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'inventory-FilteredCount',
        data: res.data.filteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  editQuantity: async (_, { id, data }) => {
    try {
      const res = await axios.put(`inventories/${id}/update-quantity`, data)
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  }
}
